import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import "./assets/App.css";
import ListItems from "./listItems";
import ListEnnemies from './listEnnemies';
import Kyiv from "./assets/i/logo.png";
import k7 from "./assets/i/k7.png";
// import screen from './assets/i/screen.png';
import chambre from "./assets/i/pictures/chambre.png";
import soldier from "./assets/i/pictures/soldier.png";
import computer from "./assets/i/pictures/computer.png";
import magazine from "./assets/i/pictures/magazine.png";
import manual from "./assets/i/pictures/manual.png";
import playing from "./assets/i/pictures/playing.png";
import poster from "./assets/i/pictures/poster.png";
import dragdrop from './assets/i/dragdrop.png';
import ChangeLangue from './changeLangue';
import { syncLanguageFromUrl } from './languageRouting';
import { applySeoForLanguage } from './seo';


function Accordion({ title, children }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="accordion-container">
      <button className="accordion-button" onClick={() => setIsOpen(!isOpen)}>
        {title}
      </button>
      {isOpen && <div className="accordion-content">{children}</div>}
    </div>
  );
}

const positionImages = () => {
  const images = document.querySelectorAll('.picdecor');
  const totalPageHeight = document.documentElement.scrollHeight;

  const viewportWidth = window.innerWidth;
  const columnWidth = 450;
  const sideSpace = (viewportWidth - columnWidth) / 2;
  const maxImageWidth = 300;

  // Calculez combien d'images peuvent tenir verticalement sans se superposer
  const zonesPerSide = Math.floor(totalPageHeight / 350);

  // Créez un tableau pour suivre les zones utilisées pour les images de gauche et de droite
  let usedZonesLeft = [];
  let usedZonesRight = [];

  images.forEach(image => {
    const randomRotation = Math.random() * 5 - 2.5;

    let randomZone;
    do {
      randomZone = Math.floor(Math.random() * zonesPerSide);
    } while ((Math.random() < 0.5 ? usedZonesLeft : usedZonesRight).includes(randomZone));

    const randomTop = randomZone * 250; // Positionnez chaque image au début de sa zone

    image.style.position = 'absolute';
    image.style.top = `${randomTop}px`;
    image.style.transform = `rotate(${randomRotation}deg)`;

    if (Math.random() < 0.5) {
      usedZonesLeft.push(randomZone); // Marquez la zone comme utilisée
      const randomLeft = Math.random() * (sideSpace - maxImageWidth);
      image.style.left = `${randomLeft}px`;
    } else {
      usedZonesRight.push(randomZone); // Marquez la zone comme utilisée
      const randomRight = Math.random() * (sideSpace - maxImageWidth) + sideSpace + columnWidth;
      image.style.left = `${randomRight}px`;
    }
  });

  // Réinitialisez les zones utilisées après chaque positionnement pour permettre des redimensionnements dynamiques
  usedZonesLeft = [];
  usedZonesRight = [];
};

function App() {

  const images = [chambre, soldier, computer, magazine, manual, playing, poster];

  useEffect(() => {
    positionImages();
    window.addEventListener('resize', positionImages);
    return () => {
      window.removeEventListener('resize', positionImages);
    };
  }, []);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    syncLanguageFromUrl(i18n, { redirectIfMissing: true });

    const onPopState = () => {
      syncLanguageFromUrl(i18n, { redirectIfMissing: false });
    };

    window.addEventListener('popstate', onPopState);
    return () => {
      window.removeEventListener('popstate', onPopState);
    };
  }, [i18n]);

  useEffect(() => {
    applySeoForLanguage(i18n.language);
  }, [i18n.language]);

  return (
    <>
      <ChangeLangue />
      <div id="conteneur">

        {images.map((image, index) => {
          return (
            <img
              key={index}
              className='picdecor'
              src={image}
              alt={`${index}`}
            />
          );
        })}

        {/*<img src="chambre.png" />*/}
        <header className="App-header">
          <h1><img src={Kyiv} className="App-logo" alt="logo" /></h1>
        </header>
        <p>
          {t('Kyiv is a mod')}{" "}
          <a href="https://zdoom.org/downloads">{t('GzDoom engine')}</a>
        </p>

        <p>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/Qy8hymLq-K0?si=Sqg1R0hcu5RXrzJm" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          {/*<img src={screen} alt="screenshot" className="image" />*/}
        </p>

        <div className="button-container">
          <a
            className="download"
            href={`${process.env.PUBLIC_URL}/KYIV.zip`}
            download="Kyiv.zip"
          >
            {t('Download Kyiv.wad')}
          </a>
        </div>

        <Accordion title={t('How to play Kyiv, step by step')}>
          <ul>
            <li>
              {t('Download')} <a href="https://zdoom.org/downloads">GzDoom</a>.
            </li>
            <li>
              {t('Install it.')}
            </li>
            <li>
              {t('Launch it')}{' '}
              <a href="https://www.moddb.com/games/doom">Doom</a>{' '}
              <a href="https://www.moddb.com/games/doom-ii/">Doom II</a>
            </li>
            <li>
              {t('Once you')}
            </li>
            <li>
              {t('To launch Kyiv.wad, you just have')}
              <img src={dragdrop} alt="drag and drop" className="screenshot" />
            </li>
          </ul>
        </Accordion>


      </div>
      <section className="story">
        <div className="summary">
          <p>
            {t('Kyiv, 2022')}
          </p>
          <p>
            {t('Their hordes unleash')}
          </p>
          <p>
            {t('In reality')}
          </p>
          <p>
            {t('In Kyiv, you embody')}
          </p>
          <p>
            <a title="u24.gov.ua" className="download" href="https://u24.gov.ua/">
              {t("Support Ukraine")}
            </a>
          </p>
        </div>


      </section>
      <section className="grid">
        <h2>{t('Items')}</h2>
        <ListItems />
      </section>
      <section className="grid ennemies">
        <h2>{t('Ennemies')}</h2>
        <ListEnnemies />
      </section>
      <section className="tribute">
        <h2>{t('Thanks')}</h2>
        <p>{t('Many tribute to the whole ID Software teams to have deliver such a banger!')}</p><br />
        <p>{t('Thanks to the large community who contributed all the tools allowing me to create Kyiv (magicaVoxel, Blender, Slab, Ultimate Doom Builder, + all addons)!')}</p><br />
        <p><a href="https://www.patreon.com/cheello_art">c𝕙ee𝕝l𝕠</a>, {t('for his crazy work voxelizing all the Doom monsters, the basis from which I started to create the ones in Kyiv.')}</p><br />
        <hr /><br />
        <p>{t('The song in introduction')} <a href="https://www.falkkone.com/music">Falkkone</a></p><br />
        <p>{t('Dilemma song')} <a href="https://www.youtube.com/watch?v=Rmd87ESHS8g">Leo_Metal</a></p><br />
        <p>{t('Training center song')} <a href="https://www.youtube.com/watch?v=03DEMih2T94">Chris Joao</a></p><br />
        <p>{t('Tryzub song')} <a href="https://www.youtube.com/watch?v=vye-6njm1Pc">HEAVY</a></p><br />
        <p>{t('Holly church of moscovie song')} <a href="https://www.youtube.com/watch?v=uzQz3NmwGXQ">Kfir Ochaion</a></p><br />
        <p>{t('Secret level song')} <a href="https://www.youtube.com/watch?v=dgruMWQPhLU">Songs For The Folk</a></p><br />
        <p>{t('Tutorial and second secret level song')}</p><br />
        <p>{t('others songs are AI generated')}</p><br /><br />
        <p>
          <a href="https://www.youtube.com/playlist?list=PLLeRk4OIhMBfpzrE3Ev74AYNbTSYYfTSE">
            {t('Listen to the whole playlist:')}
            <img src={k7} className="k7" alt="logo" />
          </a>
        </p>
      </section>
    </>
  );
}

export default App;
